import styled from 'styled-components';

import { Textarea } from '../';

export const WhiteTextarea = styled(Textarea)`
  textarea {
    background: #ffffff;
  }
`;
